import { Box, Stack, styled } from '@planne-software/uni/mui/material';
import { Button } from '@planne-software/uni/Button';

// Override the uni ScopedCssBaseline defaults so the embed inherits the
// host page background and uses the Work Sans font from the Figma design.
export const Wrapper = styled('div')({
  '.MuiScopedCssBaseline-root': {
    background: 'inherit',
    '*': {
      fontFamily: "'Work Sans', sans-serif",
    },
  },
});

export const Card = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.tokens.spacing['spacing-sm'],
  border: `1px solid ${theme.tokens.colors['border-color-neutral-softer']}`,
  borderRadius: theme.tokens.radius['border-radius-md'],
  padding: theme.tokens.spacing['spacing-xs'],
  width: '100%',

  [theme.breakpoints.up('sm')]: {
    padding: theme.tokens.spacing['spacing-sm'],
  },
}));

export const SlotsList = styled(Stack)(({ theme }) => ({
  flexDirection: 'column',
  gap: theme.tokens.spacing['spacing-1xmini'],

  '.planne-uni-paper-trigger-button-root, .planne-uni-paper-trigger-button-root span': {
    ...theme.tokens.typography['text-sm-semibold'],
    color: theme.tokens.colors['text-color-neutral-strongest'],
    opacity: 1,
  },
  '.planne-uni-paper-trigger-button-root.planne-uni-paper-trigger-button-disabled, .planne-uni-paper-trigger-button-root.planne-uni-paper-trigger-button-disabled span':
    {
      color: theme.tokens.colors['text-color-neutral-soft'],
    },
}));

export const Slot = styled(Box)(({ theme }) => ({
  height: '40px',
  width: '100%',
  backgroundColor: theme.tokens.colors['fill-color-neutral-softer'],
  borderRadius: theme.tokens.radius['border-radius-xs'],
}));

export const CtaButton = styled(Button, { shouldForwardProp: (prop) => prop !== 'actionColor' })<{
  actionColor: string;
}>(({ actionColor }) => ({
  backgroundColor: actionColor,
  '&:hover': {
    backgroundColor: actionColor,
    filter: 'brightness(0.92)',
  },
}));
